import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { hideHeader, hideLogoAndFooter, changeBgColor } from "../../../actions/appStatus.actions";
import { callBeginSession } from "../../../actions/authPayment.actions";
import { AuthPaymentErrorPage } from "../error-page/auth-payment-error-page.component";

const AuthPaymentIntakeComponent = (props) => {
  const guid = props.match.params.guid || null;

  useEffect(() => {
    props.hideLogoAndFooter();
    props.hideHeader();
    props.changeBgColor("#fcfdfe");

    props.callBeginSession(guid, props.history);
  }, []);

  if (props.authPayment.hasError) {
    return <AuthPaymentErrorPage />
  }

  return <div></div>;
};

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  hideHeader,
  changeBgColor,
  hideLogoAndFooter,
  callBeginSession,
};

//Connect to Redux store
const AuthPaymentIntake = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AuthPaymentIntakeComponent)
);

export default AuthPaymentIntake;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/intake/auth-payment-intake.component.js